import { Paragraph } from '@quickmd-llc/design-system'
import { useInterval } from '@quickmd-llc/frontend-utils'
import moment from 'moment'
import { useReducer, useRef } from 'react'
import { useDailyVisit } from 'pages/WaitingRoom/daily/hooks/useDailyVisit'
import { VisitMethods } from 'constants/VisitMethods'
import { formatElapsedMs } from 'utils/formatElapsedMs'

// Count-up pill. Mounted only while it should be visible, so the start moment is captured
// correctly per visit type (online/in-person: pop-up open; video/call: call connect). Client-side only.
const formatElapsed = (startTime: moment.Moment): string => formatElapsedMs(moment().diff(startTime))

function ElapsedPill() {
  const startTimeRef = useRef(moment())
  const [, forceRerender] = useReducer((n: number) => n + 1, 0)
  useInterval(() => forceRerender(), 1000)

  return (
    <Paragraph size='sm' className='h-fit w-fit items-center rounded-3xl bg-shade-50 px-sp-1 py-sp-0.5 text-white'>
      {formatElapsed(startTimeRef.current)}
    </Paragraph>
  )
}

export function VisitElapsedTimer() {
  const { is, patientWithVisitInfo } = useDailyVisit()
  const method = patientWithVisitInfo?.VisitMethod

  // Online + in-person are "started on open" (no call to connect); video/call start on connect.
  const show = method === VisitMethods.ASYNCHRONOUS || method === VisitMethods.INPERSON || is('CALL_IS_ACTIVE')
  if (!show) return null

  return <ElapsedPill />
}
